import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: OAuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const hasValidAccessToken = this.authService.hasValidAccessToken();
    //This logic is to fix the redirect issue when opening a new tab.
    if (state.url !== '/') localStorage.setItem('redirectURL', state.url);
    if (!hasValidAccessToken) return this.router.createUrlTree(['login']);

    return true;
  }
}
